import { atom } from 'recoil';

export const ArchImgUrl = atom({
    key: 'RI003AWS-ArchImgUrl',
    default: undefined,
});

export const isExpandArchDiagram = atom({
    key: 'RI003AWS-isExpandArchDiagram',
    default: false,
});

export const OrderPayload = atom({
    key: 'RI003AWS-OrderPayload',
    default: {
        catalogCode: null,
        projectId: null,
        projectDetails: null,
        businessUnit: null,
        sector: null,
        program: null,
        division: null,
        environment: null,
        dataClassification: null,
        budgetCode: null,
        budgetCodeDetails: null,
        billingInfo: null,
        vpcName: null,
        vpcId: null,
        nonPrivilegedADGroupList: [{ readerValue: '' }],
        privilegedADGroupList: [{ contributorValue: '' }],
        environmentDetails: null,
        adGroup: 'Yes',
        privilegedADGroup: null,
        nonPrivilegedADGroup: null,
        myCertADGroup: null,
        myCertADGroupOwner: null,
        myCertADGroupOwnerDetails: null,
        businessAppService: 'No',
        businessApp: null,
        appService: null,
        isTouched: false,
        estimatedCost: null,
        appOwner: null,
        appOwnerDetails: null,
        adCertGroup: null,
        businessContact: null,
        businessContactDetails: null,
        privilegedADGroupOwner: null,
        privilegedADGroupOwnerDetails: null,
        nonPrivilegedADGroupOwner: null,
        nonPrivilegedADGroupOwnerDetails: null,
        applicationName: null,
        appShortName: null,
        isaNumber: null,
        iteAppService: null,
        appSupportMailId: null,
        resourceMgmt: null,
        isExternal: 'No',
    },
});

export const urlParams = atom({
    key: 'urlParams',
    default: {
        journeyId: null,
        appRegistrationId: null,
    },
});

export const isGetAppShortNameLoading = atom({
    key: 'RI003AWS-isGetAppShortNameLoading',
    default: false,
});

export const isAppNameValid = atom({
    key: 'RI003AWS-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'RI003AWS-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'RI003AWS-isAppShortNameExist',
    default: false,
});

export const isBusinessNameValid = atom({
    key: 'RI003AWS-isBusinessNameValid',
    default: true,
});

export const isAdGroupValid = atom({
    key: 'RI003AWS-isAdGroupValid',
    default: false,
});

export const isEksAdGroupValid = atom({
    key: 'RI003AWS-isEksAdGroupValid',
    default: false,
});

export const isBudgetCodeValid = atom({
    key: 'RI003AWS-isBudgetCodeValid',
    default: true,
});

export const budgetCodeValidationModal = atom({
    key: 'RI003AWS-budgetCodeValidationModal',
    default: { open: false, budgetCode: '' },
});

export const isBillingInfoValid = atom({
    key: 'RI003AWS-isBillingInfoValid',
    default: true,
});

export const isProjectIdValid = atom({
    key: 'RI003AWS-isProjectIdValid',
    default: false,
});

export const adGroupErrorMsg = atom({
    key: 'RI003AWS-adGroupErrorMsg',
    default: false,
});

export const contributorErrorMsg = atom({
    key: 'RI003AWS-contributorErrorMsg',
    default: false,
});

export const isADGroupValid = atom({
    key: 'RI003AWS-isADGroupValid',
    default: true,
});

export const isBusinessAppValid = atom({
    key: 'RI003AWS-isBusinessAppValid',
    default: false,
});

export const isAppUrlValid = atom({
    key: 'RI003AWS-isAppUrlValid',
    default: false,
});

export const isAppContextPathValid = atom({
    key: 'RI003AWS-isAppContextPathValid',
    default: false,
});

export const isNonPrivilegedADGroupValid = atom({
    key: 'RI003AWS-isNonPrivilegedADGroupValid',
    default: false,
});

export const isMyCertADGroupValid = atom({
    key: 'RI003AWS-isMyCertADGroupValid',
    default: false,
});

export const isPrivilegedADGroupValid = atom({
    key: 'RI003AWS-isPrivilegedADGroupValid',
    default: false,
});

export const costEstimateState = atom({
    key: 'RI003AWS-costEstimateState',
    default: null,
});

export const toggleModal = atom({
    key: 'RI003AWS-toggleModal',
    default: {
        isADGroupModalOpen: false,
        isNonPrivilegedADGroupOpen: false,
        isPrivilegedADGroupOpen: false,
        isCost: { costType: '', isCostOpen: false },
    },
});

export const showPreviewOrder = atom({
    key: 'RI003AWS-showPreviewOrder',
    default: false,
});

export const previewDetails = atom({
    key: 'RI003AWS-previewdetails',
    default: null,
});
export const previewApiLoading = atom({
    key: 'RI003AWS-previewApiLoading',
    default: false,
});
export const isSectorDisabled = atom({
    key: 'RI003AWS-isSectorDisabled',
    default: true,
});
export const isBusinessUnitDisabled = atom({
    key: 'RI003AWS-isBusinessUnitDisabled',
    default: true,
});
export const isHcodeDisabled = atom({
    key: 'RI003AWS-isHcodeDisabled',
    default: true,
});
export const previewOrderError = atom({
    key: 'RI003AWS-previewError',
    default: {
        isPreviewError: false,
        message: '',
    },
});

export const isValidappSupportMailId = atom({
    key: 'RI003AWS-isValidappSupportMailId',
    default: false,
});
export const isValidOwners = atom({
    key: 'RI003AWS-isValidOwners',
    default: {
        isvalidAppOwner: true,
        isvalidCertificateOwnerOne: true,
        isvalidCertificateOwnerTwo: true,
    },
});
export const componentGroupsState = atom({
    key: 'RI003AWS-componentGroupsState',
    default: null,
});

export const SecondaryApprover = atom({
    key: 'RI003AWS-secondaryApprover',
    default: { selectedFieldFrom: { module: null, subModule: null }, value: { groupOwner: null, groupOwnerDetails: null } },
});

export const isValidISANumber = atom({
    key: 'RI003AWS-isValidISANumber',
    default: false,
});
